import { AccountType, ResourceUserRole } from './dto/account';

/** The least of a roster entry this needs. */
export type FeeRosterEntry = {
  role?: ResourceUserRole;
  isClient?: boolean;
  isProjectScoped?: boolean;
};

const decides = (role?: ResourceUserRole) => role === ResourceUserRole.Owner || role === ResourceUserRole.Administrator;

/**
 * Whether this person decides a fee for the client: accepts, declines or counters it.
 *
 * A fee decision is a project decision - the client agreeing to the provider's price - and has
 * nothing to do with buying software. So it is decided here, on its own, and not in the block that
 * grants subscription management; it used to be granted there, to the client account Owner only,
 * which kept the PM who requested the work out of their own fee.
 *
 * The rule the server enforces (FeeDecision): the client's Owner or Administrator on the project
 * (a project user marked isClient), or an Owner or Administrator of the client account. Contributors
 * do not decide. A project-scoped guest on the account is not the company, so only their project
 * role counts.
 */
export const isClientFeeDecider = (
  accountType: AccountType | undefined,
  accountUser?: FeeRosterEntry,
  projectUser?: FeeRosterEntry,
): boolean => {
  if (accountType !== AccountType.Client) return false;

  if (accountUser && !accountUser.isProjectScoped && decides(accountUser.role)) return true;

  return !!projectUser?.isClient && decides(projectUser.role);
};
